import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface MapaValidacionDialogData {
  provinciaEsperada: string;
  provinciaDetectada: string;
  corregimientoEsperado: string;
  corregimientoDetectado: string;
  lat: number;
  lng: number;
}

@Component({
  selector: 'app-mapa-validacion-dialog',
  templateUrl: './mapa-validacion-dialog.component.html',
  styleUrls: ['./mapa-validacion-dialog.component.scss']
})
export class MapaValidacionDialogComponent {

  constructor(
    public dialogRef: MatDialogRef<MapaValidacionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: MapaValidacionDialogData
  ) { }

  cerrar(): void {
    this.dialogRef.close();
  }
}
